import Vue from 'vue';
import Vuex from 'vuex';
import router from '../router/index';
import moment from 'moment';
import actions from "./actions";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: null,
        user: null,
        webapp_url: null,
        session_expires_at: null,
        recent_animes: [],
        recent_expires_at: null,
        trivia_animes: [],
        trivia_animes_expires_at: null,
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
        },
        setUser(state, user) {
            state.user = user;
        },
        setSessionExpiration(state, expiration) {
            state.session_expires_at = expiration;
        },
        setWebappUrl(state, url) {
            state.webapp_url = url;
        },
        setRecentAnimes(state, recent_animes) {
            state.recent_animes = recent_animes;
        },
        setRecentsExpiration(state, expiration) {
            state.recent_expires_at = expiration
        },
        setTriviaAnimes(state, animes) {
            state.trivia_animes = animes;
        },
        setTriviaAnimesExpiration(state, expiration) {
            state.trivia_animes_expires_at = expiration;
        },
    },
    getters: {
        auth: state => state.user !== null,
        guest: state => state.user === null,
        token: state => state.token,
        webapp_url: state => state.webapp_url,
        session_expires_at: state => state.session_expires_at,
        recent_animes: state => state.recent_animes,
        recent_expires_at: state => state.recent_expires_at,
        trivia_animes: state => state.trivia_animes,
        trivia_animes_expires_at: state => state.trivia_animes_expires_at,
    },
    /*actions: {
        loadAuthFromStorage(context) {
            let token = localStorage.getItem('token');
            let user = localStorage.getItem('user');

            if (token) {
                context.commit('setToken', token);
            }

            if (user) {
                context.commit('setUser', JSON.parse(user));
            }
        },
        setAuth(context, auth) {
            return new Promise((resolve) => {
                let session_expires_at = moment().add(auth.expiration_days, 'days');
                localStorage.setItem('session_expires_at', session_expires_at);
                localStorage.setItem('token', auth.token);
                localStorage.setItem('user', JSON.stringify(auth.user));
                context.commit('setToken', auth.token);
                context.commit('setUser', auth.user);
                context.commit('setSessionExpiration', session_expires_at);
                resolve();
            });
        },
        logout(context) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('session_expires_at');
            context.commit('setToken', null);
            context.commit('setUser', null);
            context.commit('setSessionExpiration', null);
            router.push('/login');
            window.location.href = '/';
        },
        setUrls(context) {
            context.commit('setWebappUrl', process.env.VUE_APP_WEBAPP_URL);
        },
        loadRecentAnimes(context) {
            const recent_animes = localStorage.getItem('recent_animes');
            const recents_expires_at = localStorage.getItem('recents_expires_at');

            if (recent_animes) {
                context.commit('setRecentAnimes', JSON.parse(recent_animes));
                context.commit('setRecentsExpiration', recents_expires_at);
            }
        },
        setRecentAnimes(context, recentAnimes) {
            const recent_expires_at = moment().add(1, 'minutes');
            localStorage.setItem('recents_expires_at', recent_expires_at);
            localStorage.setItem('recent_animes', JSON.stringify(recentAnimes));
            context.commit('setRecentAnimes', recentAnimes);
            context.commit('setRecentsExpiration', recent_expires_at);
        },
    },*/
    actions,
    modules: {}
});
